export const SET_SHOW_EVENTS_MODAL = 'SET_SHOW_EVENTS_MODAL';

export interface SetShowEventsModalAction {
  type: typeof SET_SHOW_EVENTS_MODAL;
  showEventsModal: boolean;
}

export type EventsActions = SetShowEventsModalAction;

export const setShowEventsModal = (showEventsModal: boolean): SetShowEventsModalAction => ({
  type: SET_SHOW_EVENTS_MODAL,
  showEventsModal
});
